import { BaseModel } from 'paliari-js-utils'
import { required } from 'vuelidate/lib/validators'

export const attributes = () => ({
  id: null,
  descricao: '',
  checklist: [],
  tipo: 'vistoria',
})

export default class Formulario extends BaseModel {
  constructor(obj) {
    super(attributes(), obj)
  }

  static get validations() {
    return {
      descricao: { required },
      tipo: { required },
    }
  }
}
